<template>
  <div>
    <div class="my flex-left">
      <div class="navs">
        <div class="flex-left-center">
          <!-- 个人头像 -->
          <div class="img">
            <el-upload class="avatar-uploader" drag :action="burl + '/api/v1/upload'" multiple :show-file-list="false"
              :on-success="handleAvatarSuccess" :before-upload="beforeAvatarUpload">
              <img src="../assets/ellipse.png" v-if="!my.photo && !imageUrl" class="avatar" />
              <img :src="my.photo" v-else-if="my.photo && !imageUrl" class="avatar" />
              <img :src="imageUrl" v-else-if="imageUrl" />
            </el-upload>
          </div>
          <!-- 昵称 -->
          <div class="el_input">
            <div class="name flex-left-center" v-if="showName">
              {{ my.username || my.phone || my.email }}
              <i class="el-icon-edit" @click="showName = false"></i>
            </div>
            <el-input placeholder="请输入内容" v-model="input2" v-else>
              <template slot="append">
                <div>
                  <i class="el-icon-check" slot="suffix" @click="check"> </i>
                  <i class="el-icon-close" slot="suffix" @click="close"> </i>
                </div>
              </template>
            </el-input>
            <div class="phono">{{ my.phone }}</div>
          </div>
        </div>
        <div style="border-top: #e5e6eb solid 1px; width: 100%; margin: 16px 0"></div>
        <!-- 上半部分 -->
        <div class="col flex-left-center" :class="nav == item.name ? 'checked' : ''" v-for="item in navList1"
          @click="nav = item.name" :key="item.name">
          <img :src="item.img" v-show="nav == item.name" />
          <img :src="item.img2" v-show="nav != item.name" />
          {{ item.name }}
        </div>
        <!-- 分割线 -->
        <div style="border-top: #e5e6eb solid 1px; width: 100%; margin: 16px 0"></div>
        <!-- 下半部分 -->
        <div class="col flex-left-center" :class="nav == item.name ? 'checked' : ''" v-for="item in navList2"
          @click="nav = item.name" :key="item.name">
          <img :src="item.img" v-show="nav == item.name" />
          <img :src="item.img2" v-show="nav != item.name" />
          {{ item.name }}
        </div>
      </div>
      <div class="content">
        <div class="flex-between-left but">
          <el-tabs style="flex: 1" v-model="nav" v-show="nav == '我的转让' ||
            nav == '我的受让' ||
            nav == '质押融资' ||
            nav == '质押融资审核' ||
            nav == '我的维权'
            ">
            <el-tab-pane :label="`转让情况 ${zrcount}`" name="我的转让"></el-tab-pane>
            <el-tab-pane :label="`受让情况 ${srcount}`" name="我的受让"></el-tab-pane>
            <el-tab-pane :label="`质押融资`" name="质押融资" v-if="!isBankCertified"></el-tab-pane>
            <el-tab-pane :label="`质押融资审核`" name="质押融资审核" v-if="isBankCertified"></el-tab-pane>
            <!-- <el-tab-pane :label="`维权情况`" name="我的维权"></el-tab-pane> -->
          </el-tabs>
          <el-button v-show="nav == '我的转让'" class="a" type="primary" @click="djZr">
            登记转让信息
          </el-button>
          <el-button v-show="nav == '质押融资'" class="a" type="primary" @click="initiateFinancing">
            发起融资
          </el-button>
        </div>
        <!-- 我的转让 -->
        <div v-show="nav == '我的转让'" class="zhaun_rang">
          <div class="flex-left flex-wrap tabs" style="width: 100%">
            <div class="col flex-center" v-for="(item, index) in tabList" :key="index"
              :class="tab == item.name ? 'checked' : ''" @click="zrTabChange(item.name)">
              <div>
                <div class="flex-center">{{ item.n }}</div>
                <div>
                  {{ item.name }}
                </div>
              </div>
            </div>
          </div>

          <!-- <div class="flex-left-center">
            <div class="sou_suo flex-between">
              <input type="text" placeholder="输入知产名称或项目编号" />
              <i class="el-icon-search"></i>
            </div>
            <div class="ri_li">
              <el-date-picker
                v-model="date"
                type="date"
                placeholder="选择日期"
                size="small"
              >
              </el-date-picker>
            </div>
            <el-select
              v-model="optionsvalue"
              placeholder="综合排序"
              size="small"
            >
              <el-option
                v-for="item in options"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              >
              </el-option>
            </el-select>
          </div> -->

          <div class="list">
            <div class="col" v-for="(item, index) in zrList" :key="index">
              <div class="col_1">
                <div class="flex-left" style="width: 100%">
                  <div class="img flex-center" v-if="item.topimg">
                    <img :src="item.topimg" />
                  </div>

                  <div style="width: 100%">
                    <div class="flex-between" style="width: 100%">
                      <router-link class="title" :to="`/my/zhuanrang?id=${item.id}`">{{ item.name }}</router-link>
                      <div class="zhaung_tai b flex-end-center">
                        {{ item.status }}

                        <el-button v-show="item.status == '已退回'" size="medium" @click="dialogHuitui = true"
                          style="margin-left:12px">
                          查看原因
                        </el-button>
                      </div>
                    </div>
                    <div class="bian_hao">
                      项目编号：
                      <span>{{ item.code }}</span>
                    </div>
                    <div class="yi_xiang">
                      意向人：
                      <span>{{ item.intentions.length }}</span>
                    </div>
                  </div>
                </div>

                <div style="
                    border-top: #e5e6eb solid 1px;
                    width: 100%;
                    margin: 16px 0;
                  "></div>

                <div v-if="item.event" class="flex-between" style="margin-bottom: 14px">
                  <div class="yi_xiang_xx">挂牌流程</div>
                  <div class="shou_qi flex-end-center" @click="jiaListChange(index, item.id)">
                    <span v-show="jiaListCol == index">收起</span>
                    <span v-show="jiaListCol != index">展开</span>
                    <img :class="jiaListCol == index ? 'checked_img' : ''" src="../assets/xia.png" />
                  </div>
                </div>

                <div v-if="item.event" v-show="jiaListCol != index" class="flex-between col_labe">
                  <span>{{ item.event.describe }}</span>
                  <span>{{ item.event.createTime | formatDate }}</span>
                </div>

                <div class="col_list" :class="jiaListCol == index ? 'checked_list' : ''">
                  <div v-for="(n, i) in lcData.ds" :key="i">
                    <div class="flex-between col_labe">
                      <span>{{ n.describe }}</span>
                      <span>{{ n.createTime | formatDate }}</span>
                    </div>

                    <el-table v-if="n.describe == '受让意向确认'" :data="[lcData.mrr]" style="width: 100%; margin: 6px 0"
                      stripe>
                      <el-table-column prop="name" label="意向受让方名称">
                      </el-table-column>

                      <el-table-column prop="contactPerson" label="联系人" width="100">
                      </el-table-column>

                      <el-table-column prop="recvConfirmMethod" label="受让确认方式">
                      </el-table-column>
                      <el-table-column prop="recvQualification" label="最终受让资格">
                      </el-table-column>
                      <el-table-column prop="confirmDate" label="确认日期" width="180">
                        <template slot-scope="scope">
                          <div>
                            {{ scope.row.confirmDate | formatDate }}
                          </div>
                        </template>
                      </el-table-column>
                    </el-table>

                    <el-table :data="lcData.mrs" style="width: 100%; margin: 6px 0" stripe v-if="n.describe == '受让意向登记'">
                      <el-table-column prop="name" label="意向受让方名称">
                      </el-table-column>
                      <el-table-column prop="contactPerson" label="联系人" width="100">
                      </el-table-column>
                      <el-table-column prop="contactInfo" label="联系方式" width="140">
                      </el-table-column>
                      <el-table-column prop="earnestMoney" label="保证金" width="100">
                        <!-- <template slot-scope="scope">
                          <div
                            :class="scope.row.jin == '已缴纳' ? 'lv' : 'hong'"
                          >
                            {{ scope.row.jin }}
                          </div>
                        </template> -->
                      </el-table-column>
                      <el-table-column prop="markDate" label="意向日期" width="180">
                        <template slot-scope="scope">
                          <div>
                            {{ scope.row.markDate | formatDate }}
                          </div>
                        </template>
                      </el-table-column>
                    </el-table>
                  </div>
                </div>
              </div>

              <div class="col_2 flex-between">
                <div class="ti_jiao">
                  提交日期：
                  <span>{{ item.time }}</span>
                </div>
                <div class="buttons flex-end-center">
                  <router-link class="flex-center" v-if="item.status == '已退回' || item.status == '暂存'"
                    :to="`/transferregistration?id=${item.id}`">
                    重新登记
                  </router-link>

                  <router-link class="flex-center" :to="`/my/zhuanrang?id=${item.id}`">
                    查看详情
                  </router-link>

                  <div class="flex-center" v-if="item.status == '已发布'">
                    中止
                  </div>
                  <div class="flex-center" v-if="item.status == '已发布'">
                    终止
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div class="flex-center fen_ye">
            <el-pagination background @size-change="handleSizeChange" @current-change="handleCurrentChange"
              :current-page.sync="currentPage" :page-size="zrsize" layout="prev, pager, next, jumper" :total="zrcount">
            </el-pagination>
          </div>
        </div>
        <!-- 我的受让 -->
        <div v-show="nav == '我的受让'" class="zhaun_rang">
          <div class="flex-between tabs" style="width: 100%">
            <div class="flex-left">
              <div class="col flex-center" style="padding: 10px 28px 0" v-for="(item, index) in tabList2" :key="index"
                :class="tab2 == item.name ? 'checked' : ''" @click="srTabChange(item.name)">
                <div>
                  <div class="flex-center">{{ item.n }}</div>
                  <div>
                    {{ item.name }}
                  </div>
                </div>
              </div>
            </div>
          </div>

          <!-- <div class="flex-left-center">
            <div class="sou_suo flex-between">
              <input type="text" placeholder="输入知产名称或项目编号" />
              <i class="el-icon-search"></i>
            </div>
            <div class="ri_li">
              <el-date-picker
                v-model="date"
                type="date"
                placeholder="选择日期"
                size="small"
              >
              </el-date-picker>
            </div>
            <el-select
              v-model="optionsvalue"
              placeholder="综合排序"
              size="small"
            >
              <el-option
                v-for="item in options"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              >
              </el-option>
            </el-select>
          </div> -->

          <div class="list">
            <div class="col" v-for="(item, index) in srList" :key="index">
              <div class="col_1">
                <div class="flex-left" style="width: 100%">
                  <div class="img flex-center">
                    <img :src="item.topimg" />
                  </div>
                  <div style="width: 100%">
                    <div class="flex-between" style="width: 100%">
                      <router-link class="title" :to="`/my/shourang?id=${item.id}`" target="_blank">{{ item.name
                      }}</router-link>
                      <div class="zhaung_tai b">
                        {{ item.status }}
                      </div>
                    </div>
                    <div class="bian_hao">
                      项目编号：
                      <span>{{ item.code }}</span>
                    </div>
                  </div>
                </div>
                <div style="
                    border-top: #e5e6eb solid 1px;
                    width: 100%;
                    margin: 16px 0;
                  "></div>
                <div class="flex-between">
                  <div class="yi_xiang_xx">挂牌流程</div>
                  <div class="shou_qi flex-end-center" @click="jiaListChange1(index, item.id)">
                    <span v-show="jiaListCol == index">收起</span>
                    <span v-show="jiaListCol != index">展开</span>
                    <img :class="jiaListCol == index ? 'checked_img' : ''" src="../assets/xia.png" />
                  </div>
                </div>

                <div v-show="jiaListCol != index" class="flex-between col_labe">
                  <span>{{ item.describe.describe }}</span>
                  <span>{{ item.describe.createTime | formatDate }}</span>
                </div>

                <div class="col_list" :class="jiaListCol == index ? 'checked_list' : ''">
                  <div v-for="(n, i) in lcData.ds" :key="i">
                    <div class="flex-between col_labe">
                      <span>{{ n.describe }}</span>
                      <span>{{ n.createTime | formatDate }}</span>
                    </div>

                    <el-table v-if="n.describe == '受让意向确认'" :data="[lcData.mrr]" style="width: 100%; margin: 6px 0"
                      stripe>
                      <el-table-column prop="name" label="意向受让方名称">
                      </el-table-column>
                      <el-table-column prop="contactPerson" label="联系人" width="100">
                      </el-table-column>
                      <el-table-column prop="recvConfirmMethod" label="受让确认方式">
                      </el-table-column>
                      <el-table-column prop="recvQualification" label="最终受让资格">
                      </el-table-column>
                      <el-table-column prop="confirmDate" label="确认日期" width="180">
                        <template slot-scope="scope">
                          <div>
                            {{ scope.row.confirmDate | formatDate }}
                          </div>
                        </template>
                      </el-table-column>
                    </el-table>
                    <el-table :data="lcData.mrs" style="width: 100%; margin: 6px 0" stripe v-if="n.describe == '受让意向登记'">
                      <el-table-column prop="name" label="意向受让方名称">
                      </el-table-column>
                      <el-table-column prop="contactPerson" label="联系人" width="100">
                      </el-table-column>
                      <el-table-column prop="contactInfo" label="联系方式" width="140">
                      </el-table-column>
                      <el-table-column prop="earnestMoney" label="保证金" width="100">
                      </el-table-column>
                      <el-table-column prop="markDate" label="意向日期" width="180">
                        <template slot-scope="scope">
                          <div>
                            {{ scope.row.markDate | formatDate }}
                          </div>
                        </template>
                      </el-table-column>
                    </el-table>
                  </div>
                </div>
              </div>
              <div class="col_2 flex-between">
                <div class="ti_jiao">
                  提交日期：
                  <span>{{ item.time }}</span>
                </div>
                <div class="buttons flex-end-center">
                  <!-- <a class="flex-center lan" target="_blank" :href="downloadUrl" v-if="item.status == '已成交'">
                    下载合同
                  </a>

                  <a class="flex-center lan" href="javascript:;" @click="quZhiFu(item)" v-if="item.status == '已成交'">
                    {{ pdZf(item.id) ? "已支付" : '去支付' }}
                  </a> -->

                  <router-link class="flex-center" :to="`/my/shourang?id=${item.id}`">
                    查看详情
                  </router-link>

                  <router-link class="flex-center" v-if="item.status == '已退回'"
                    :to="`/details/initiatingassignment?id=${item.markReleaseId}`">
                    重新登记
                  </router-link>

                </div>
              </div>
            </div>
          </div>

          <div class="flex-center fen_ye">
            <el-pagination background @size-change="handleSizeChange1" @current-change="handleCurrentChange1"
              :current-page.sync="currentPage1" :page-size="srsize" layout="prev, pager, next, jumper" :total="srcount">
            </el-pagination>
          </div>
        </div>
        <!-- 质押融资列表 -->
        <div v-show="nav == '质押融资'" class="rong_zi">
          <div class="col" v-for="(item, index) in rzList" :key="index" @click="goToFinancingDetail(item)" style="cursor: pointer;">
            <el-descriptions :column="2">
              <el-descriptions-item label="企业全称">
                {{ item.qyqc }}
              </el-descriptions-item>

              <el-descriptions-item label="企业联系人">
                {{ item.qylxr }}
              </el-descriptions-item>

              <el-descriptions-item label="联系方式">
                {{ item.lxfs }}
              </el-descriptions-item>

              <el-descriptions-item label="拟融资规模">
                {{ item.nrzgm }}万
              </el-descriptions-item>

              <el-descriptions-item label="企业简介">
                {{ item.qyjj }}
              </el-descriptions-item>

              <el-descriptions-item label="无形资产对应关系">
                {{ item.wxcps }}
              </el-descriptions-item>
            </el-descriptions>

            <el-divider></el-divider>

            <div class="flex-between" style="font-size: 14px">
              <div>提交日期：{{ item.createTime | formatDate3 }}</div>
              <div>当前状态：{{ item.status | rzStatus }}</div>
            </div>
          </div>

          <div class="flex-center fen_ye">
            <el-pagination background @size-change="rzSizeChange" @current-change="rzCurrentChange"
              :current-page.sync="currentPage2" :page-size="rzpage.size" layout="prev, pager, next, jumper"
              :total="rzcount">
            </el-pagination>
          </div>
        </div>

        <!-- 质押融资审核列表 -->
        <div v-show="nav == '质押融资审核'" class="rong_zi">
          <div class="review-card" v-for="(item, index) in rzReviewList" :key="index" v-loading="loading">
            <div class="card-header">
              <div class="company-section">
                <div class="company-name">{{ item.enterprise || item.qyqc || '桦霖展览展示设计(上海)有限公司北京分公司' }}</div>
                <div class="status-section">
                  <span class="status-label">当前状态:</span>
                  <span class="status-value" :class="getStatusClass(item.status)">{{ getStatusText(item.status) }}</span>
                </div>
              </div>
            </div>
            
            <div class="card-content">
              <div class="info-row">
                <span class="info-label">申请人姓名:</span>
                <span class="info-value">{{ item.name || item.qylxr || '张三' }}</span>
              </div>
              <div class="info-row">
                <span class="info-label">单据编号:</span>
                <span class="info-value document-link">{{ item.id || 'CQ00018962' }}</span>
              </div>
              <div class="info-row">
                <span class="info-label">单据现状:</span>
                <span class="info-value status-badge">进行</span>
              </div>
            </div>
            
            <div class="card-footer">
              <div class="date-section">
                <span class="date-label">申请日期:</span>
                <span class="date-value">{{ getDateText(item.createTime, item.submitTime) }}</span>
              </div>
              <div class="amount-section">
                <span class="amount-label">申请金额:</span>
                <span class="amount-value">{{ item.nrzgm || item.amount || '240' }}万</span>
              </div>
            </div>
          </div>

          <div class="flex-center fen_ye">
            <el-pagination background @size-change="rzReviewSizeChange" @current-change="rzReviewCurrentChange"
              :current-page.sync="currentPage3" :page-size="rzReviewPage.size" layout="prev, pager, next, jumper"
              :total="rzReviewCount">
            </el-pagination>
          </div>
        </div>
      </div>
    </div>

    <el-dialog title="交易申请与承诺" :visible.sync="centerDialogVisible" width="50%" center>
      <div class="promise">
        <p>上海知识产权交易中心：</p>
        <p>本申请人依照公开、公平、公正、诚信的原则作如下承诺：</p>
        <p>1、本次交易是我方真实意愿表示。</p>
        <p>
          2、交易标的权属清晰，我方对交易标的拥有完全的处置权且处置权的实施不存在任何限制条件；交易标的涉及共有或他项权利的，已获得相关权利人同意的有效文件。
        </p>
        <p>
          3、我方所提交的《知识产权信息发布申请书》及交易材料（包括原件、复印件）不存在虚假、误导性或重大遗漏；我方对上述材料的真实性、合法性、完整性承担责任，并同意上海知识产权交易中心按上述材料内容发布公告。
        </p>
        <p>
          4、我方已充分了解并承诺在知识产权交易过程中遵守法律法规和上海知识产权交易中心相关交易规则及各项规定，按照有关要求履行我方义务。
        </p>
        <p>
          5、我方已如实完整地披露标的情况，若成交后发生移交纠纷，由我方负责解决。
        </p>
        <p>
          6、我方已知悉并认可上海知识产权交易中心的收费项目及标准，同意按规定交纳相关费用。
        </p>
        <div class="checkbox">
          <el-checkbox v-model="checked">我方保证遵守以上承诺，如违反上述承诺或有违规行为，给交易相关方造成损失的，我方愿意承担法律责任及相应的经济赔偿责任。</el-checkbox>
        </div>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button :disabled="!checked" type="primary" @click="openCeshi" style="width: 160px">我要发布</el-button>
      </span>
    </el-dialog>

    <!-- 转让退回原因弹框 -->
    <el-dialog title="审批结果" :visible.sync="dialogHuitui" width="30%">
      <span>已退回</span>

      <span slot="footer" class="dialog-footer">
        <el-button type="primary" @click="dialogHuitui = false">
          确 定
        </el-button>
      </span>
    </el-dialog>

    <!-- 支付窗口(仅限测试服) -->
    <el-dialog :visible.sync="zfbTc" width="1000px">
      <div class="zf_tanchuang" v-show="zfbjd == 1">
        <img class="zf_bg" src="../assets/zfb_jia.png" alt="">
        <div class="price flex-center">50000.00</div>
        <div class="zfcg_bt" @click="zhiFuCg">已支付成功</div>
      </div>
      <div class="zf_tanchuang" style="padding-top:110px" v-show="zfbjd == 2">
        <img class="cg_icon" src="../assets/cheng_gong.png" alt="">
        <div class="flex-center cg_tishi">支付成功</div>
        <div class="flex-center">
          <div class="zffh_bt" @click="zfbTc = false">返回订单列表</div>
        </div>
      </div>
    </el-dialog>

  </div>
</template>

<script>
import { setUSER, getUSER } from "../api/constant";
import MyHead from "../components/MyHead.vue";
import MyFooter from "../components/MyFooter.vue";
import PersonalEdit from "../components/PersonalEdit.vue";
import { getRequest, postRequest, goCertCenter } from "../api/api";
import { baseUrl } from "../api/constant";
import { formatDate, formatDate3 } from "../api/util";

const base = process.env.VUE_APP_BASE;
const domain = process.env.VUE_APP_DOMAIN;


export default {
  name: "myembed",
  components: {
    MyHead,
    MyFooter,
    PersonalEdit,
  },
  computed: {
    burl() {
      return baseUrl;
    },
    downloadUrl() {
      let url = window.location.href;
      return `${url.split("#")[0]}static/he_tong.pdf`;
    },
    isBankCertified() {
      // 判断银行认证是否已通过
      return this.shouQuanData.bank && this.shouQuanData.bank.status === 1;
    },
  },
  watch: {
    zrpage() {
      this.getZrList();
      this.jiaListCol = null;
    },
    srpage() {
      this.getSrlist();
      this.jiaListCol = null;
    },
    nav() {
      this.jiaListCol = null;
    },
    rzpage: {
      handler(item1, item2) {
        this.getFinancing();
      },
      deep: true,
    },
    isBankCertified: {
      handler(newVal, oldVal) {
        // 当银行认证状态改变时，如果当前在"质押融资"Tab但银行认证已通过，自动切换到"质押融资审核"Tab
        if (newVal && !oldVal && this.nav === '质押融资') {
          this.nav = '质押融资审核';
        }
      },
      immediate: true
    },
  },
  //过滤器
  filters: {
    formatDate(val) {
      return formatDate(val);
    },
    formatDate3(val) {
      return formatDate3(val);
    },
    rzStatus(val) {
      // 转换为数字进行比较，处理字符串类型的状态值
      const status = parseInt(val);
      if (status === 0) {
        return "已提交";
      } else if (status === 1) {
        return "金融部审核通过";
      } else if (status === 2) {
        return "金融部审核退回";
      } else if (status === 3) {
        return "银行已通过";
      } else if (status === 4) {
        return "银行已拒绝";
      } else if (val == 'initial_review' || val === '初审') {
        return "初审";
      } else if (val == 're_review' || val === '复审') {
        return "复审";
      } else {
        return "处理中";
      }
    },
  },
  data() {
    return {
      showName: true,
      input2: "",
      key: 0,
      imageUrl: "",
      my: {},
      centerDialogVisible: false,
      checked: false,
      navList1: [
        {
          name: "我的转让",
          img: require("../assets/icon/my_1.png"),
          img2: require("../assets/icon/my_2.png"),
        },
        {
          name: "我的受让",
          img: require("../assets/icon/my_3.png"),
          img2: require("../assets/icon/my_4.png"),
        },
        {
          name: "质押融资",
          img: require("../assets/icon/my_5.png"),
          img2: require("../assets/icon/my_6.png"),
        },
      ],
      navList2: [
        // {
        //   name: "我的维权",
        //   img: require("../assets/icon/my_7.png"),
        //   img2: require("../assets/icon/my_8.png"),
        // },
        // {
        //   name: "知产培训",
        //   img: require("../assets/icon/my_9.png"),
        //   img2: require("../assets/icon/my_10.png"),
        // },
      ],
      nav: "我的转让",
      tabList: [
        { name: "全部", n: 0 },
        { name: "暂存", n: 0 },
        { name: "受理中", n: 0 },
        { name: "已退回", n: 0 },
        // { name: "待发布", n: 0 },
        { name: "已发布", n: 0 },
        { name: "已成交", n: 0 },
        { name: "已到期", n: 0 },
        { name: "中止", n: 0 },
        { name: "终止", n: 0 },
      ],
      tabList2: [
        { name: "全部", n: 0 },
        { name: "受理中", n: 0 },
        { name: "已退回", n: 0 },
        { name: "已成交", n: 0 },
        { name: "已发布", n: 0 },
        { name: "已到期", n: 0 },
      ],
      tab: "全部",
      tab2: "全部",
      date: "",
      options: [
        {
          value: "综合排序",
          label: "综合排序",
        },
        {
          value: "选项1",
          label: "选项1",
        },
        {
          value: "选项2",
          label: "选项2",
        },
      ],
      optionsvalue: "综合排序",
      currentPage: 1,
      currentPage1: 1,
      currentPage2: 1,
      jiaListCol: null,
      personalEditShow: false, //个人授权认证弹窗
      shouQuanData: {
        enterpriseOthers: [],
        enterprises: [],
        bank: null,
        realnameAuthPO: null,
      },
      zrList: [], //我的转让列表
      zrpage: 0,
      zrsize: 10,
      zrcount: 0,
      srList: [], //受让列表
      srpage: 0,
      srsize: 10,
      srcount: 0,
      lcData: {
        mrr: null,
        mrs: [],
        ds: [],
      },
      rzpage: {
        page: 0,
        size: 10,
      },
      rzList: [], //质押融资列表
      rzcount: 0,
      rzReviewPage: {
        page: 0,
        size: 10,
      },
      rzReviewList: [], //质押融资审核列表
      rzReviewCount: 0,
      currentPage3: 1,
      ctype: 0, //当前授权为境内(0)或境外(1)
      dialogHuitui: false, //退回原因弹框
      zfbTc: false, //支付宝弹窗
      zfbjd: 1,
      zfbDdId: null,
    };
  },
  methods: {
    // 判断是否支付
    pdZf(id) {
      let list = JSON.parse(localStorage.getItem('zfList')) || []
      console.log("list", list.indexOf(id));
      if (list.indexOf(id) == -1) return false
      else return true
    },
    // 受让->去支付
    quZhiFu(value) {
      if (this.pdZf(value.id)) return
      this.zfbTc = true
      this.zfbDdId = value.id
    },
    // 支付成功
    zhiFuCg() {
      this.zfbjd = 2
      let zflist = JSON.parse(localStorage.getItem('zfList')) || []
      zflist.push(this.zfbDdId)
      localStorage.setItem('zfList', JSON.stringify(zflist))
    },
    //根据境内外类型打开个人认证窗口
    changeEditShow() {
      goCertCenter();
    },
    // 融资分页函数
    rzSizeChange(val) {
      this.rzpage.size = val;
      this.getFinancing();
    },
    rzCurrentChange(val) {
      this.rzpage.page = val - 1;
      this.getFinancing();
    },
    // 获取质押融资列表
    getFinancing() {
      let data = { ...this.rzpage };
      // 添加当前登录用户ID作为过滤条件
      const currentUser = getUSER();
      if (currentUser && currentUser.id) {
        data.createUser = currentUser.id;
      }
      getRequest({ url: "/api/v1/valuation-form", data }).then((res) => {
        this.rzList = res.data;
        this.rzcount = res.totalCount;
      });
    },
    // 获取质押融资审核列表
    getFinancingReview() {
      let data = this.rzReviewPage;
      getRequest({ url: "/api/v1/valuation-form", data }).then((res) => {
        this.rzReviewList = res.data;
        this.rzReviewCount = res.totalCount;
      });
    },
    // 审核分页函数
    rzReviewSizeChange(val) {
      this.rzReviewPage.size = val;
      this.getFinancingReview();
    },
    rzReviewCurrentChange(val) {
      this.rzReviewPage.page = val - 1;
      this.getFinancingReview();
    },
                   // 审核申请
    reviewApplication(item) {
      this.$router.push({
        name: "valuationreview",
        params: { id: item.id }
      });
    },
    // 进入质押融资详情页面
    goToFinancingDetail(item) {
      this.$router.push(`/valuationdetail/${item.id}`);
    },
    // 发起融资
    initiateFinancing() {
      this.$router.push({
        name: "valuationform",
        query: { source: "my" }
      });
    },
    
    // 获取状态类型
    getStatusType(status) {
      switch (status) {
        case 0:
          return 'warning'; // 已提交
        case 1:
          return 'success'; // 金融部审核通过
        case 2:
          return 'danger'; // 金融部审核退回
        case 3:
          return 'success'; // 银行已通过
        case 4:
          return 'danger'; // 银行已拒绝
        default:
          return 'info';
      }
    },
    // 获取状态文本
    getStatusText(status) {
      // 转换为数字进行比较，处理字符串类型的状态值
      const statusNum = parseInt(status);
      if (status === '初审' || status === 'initial_review') {
        return '初审';
      } else if (status === '复审' || status === 're_review') {
        return '复审';
      } else if (statusNum === 0) {
        return "已提交";
      } else if (statusNum === 1) {
        return "金融部审核通过";
      } else if (statusNum === 2) {
        return "金融部审核退回";
      } else if (statusNum === 3) {
        return "银行已通过";
      } else if (statusNum === 4) {
        return "银行已拒绝";
      } else {
        return "处理中";
      }
    },
    // 登记转让按钮触发
    djZr() {
      window.open(`${domain}${base}my`, '_blank')
    },
    // 获取受让tab
    getSrTab() {
      getRequest({ url: "/api/v1/markReleaseRecv/statusCount" }).then((res) => {
        if (res.errcode == 200) {
          let arr = JSON.parse(res.data);
          this.tabList2.forEach((item) => {
            for (let i in arr) {
              if (item?.name == i) {
                item.n = arr[i];
              }
            }
          });
          this.getSrlist();
        } else {
          this.$message.error(res.errmsg);
        }
      });
    },
    // 获取受让列表
    getSrlist() {
      let data = {
        page: this.srpage,
        size: this.srsize,
      };
      if (this.tab2 != "全部") data.type = this.tab2;
      else data.type = null;
      getRequest({ url: "/api/v1/markRelease/myRecvList", data }).then(
        (res) => {
          if (res.errcode == 200) {
            if (res.data.mrs && res.data.mrs.length > 0) {
              this.srList = res.data.mrs.map((item) => {
                item.time = this.$moment(item.time).format("YYYY-MM-DD");
                if (item.image) {
                  item.topimg = JSON.parse(item.image)[0];
                }
                return item;
              });
            } else {
              this.srList = [];
            }
            this.srcount = res.data.count || 0;
          } else {
            this.$message.error(res.errmsg);
          }
        }
      );
    },

    // 上传修改保存信息
    next() {
      let data = {
        photo: this.imageUrl,
        // username:this.input2
      };
      postRequest({ url: "/api/v1/user/updateUser", data }).then(
        async (res) => {
          console.warn(res, "有图吗");
          if (res.errcode == 200) {
            await this.getUser();
            setUSER(this.my);
            // 刷新header组件
            this.key++;
          } else {
            this.imageUrl = "";
            // 刷新header组件
            this.key++;
            this.$message.error(res.errmsg);
          }
        }
      );
    },

    // 个人头像上传.....................
    handleAvatarSuccess(res, file) {
      this.imageUrl = res.data.webPath;
      this.next();
    },
    beforeAvatarUpload(file) {
      const isJPG = file.type === "image/jpeg";
      const isLt2M = file.size / 1024 / 1024 < 2;

      if (!isJPG) {
        this.$message.error("上传头像图片只能是 JPG 格式!");
      }
      if (!isLt2M) {
        this.$message.error("上传头像图片大小不能超过 2MB!");
      }
      return isJPG && isLt2M;
    },
    // .......................

    check() {
      let data = {
        username: this.input2,
      };
      postRequest({ url: "/api/v1/user/updateUser", data }).then(
        async (res) => {
          console.warn(res, "有图吗");
          if (res.errcode == 200) {
            await this.getUser();
            setUSER(this.my);
          } else {
            this.$message.error(res.errmsg);
          }
          this.close();
        }
      );
    },
    close() {
      this.input2 = "";
      this.showName = true;
    },
    // 获取转让tab
    getZrTab() {
      getRequest({ url: "/api/v1/markRelease/statusCount" }).then((res) => {
        if (res.errcode == 200) {
          let arr = JSON.parse(res.data);
          this.tabList.forEach((item) => {
            for (let i in arr) {
              if (item?.name == i) {
                item.n = arr[i];
              }
            }
          });
          this.getZrList();
        } else {
          this.$message.error(res.errmsg);
        }
      });
    },
    // 转让tab切换
    zrTabChange(n) {
      this.tab = n;
      this.getZrList();
    },
    // 获取我的转让列表
    getZrList() {
      let data = {
        page: this.zrpage,
        size: this.zrsize,
      };
      if (this.tab != "全部") data.type = this.tab;
      else data.type = null;
      getRequest({ url: "/api/v1/markRelease/myList", data }).then((res) => {
        if (res.errcode == 200) {
          if (res.data.mrs && res.data.mrs.length > 0) {
            this.zrList = res.data.mrs.map((item) => {
              item.time = this.$moment(item.time).format("YYYY-MM-DD");
              if (item.image) {
                item.topimg = JSON.parse(item.image)[0];
              }
              return item;
            });
          } else {
            this.zrList = [];
          }
          this.zrcount = res.data.count;
        } else {
          this.$message.error(res.errmsg);
        }
      });
    },
    // 受让tab切换
    srTabChange(n) {
      this.tab2 = n;
      this.getSrlist();
    },
    // 跳转企业认证（一网融合）
    toEnterprisecertification() {
      goCertCenter();
    },
    // 跳转第三方企业认证（一网融合）
    toEnterprisethirdparty() {
      goCertCenter();
    },
    // 跳转银行认证列表
    toBankcertification(n) {
      // 银行认证功能在My.vue中实现
      this.$router.push("/my");
    },
    // 关闭个人认证弹窗
    paginationClose() {
      this.personalEditShow = false;
      this.getShouQuan();
    },
    // 个人认证弹窗关闭时调用
    handleClose() {
      this.personalEditShow = false;
      this.$refs.personal.initial();
    },
    openCeshi() {
      this.centerDialogVisible = false;
      this.$router.push("/transferregistration");
      this.checked = false;
    },
    // 转让挂牌流程展开以及获取
    jiaListChange(i, id) {
      if (this.jiaListCol == i) {
        this.jiaListCol = null;
      } else {
        this.getLiucheng(id, i);
      }
    },
    getLiucheng(id, i) {
      getRequest({ url: "/api/v1/markRelease/flowPath?id=" + id }).then(
        (res) => {
          if (res.data) this.lcData = res.data;
          this.jiaListCol = i;
        }
      );
    },
    // 受让挂牌流程展开以及获取
    jiaListChange1(i, id) {
      if (this.jiaListCol == i) {
        this.jiaListCol = null;
      } else {
        this.getLiucheng1(id, i);
      }
    },
    getLiucheng1(id, i) {
      getRequest({ url: `/api/v1/markReleaseRecv/flowPath?id=${id}` }).then(
        (res) => {
          if (res.data) this.lcData = res.data;
          this.jiaListCol = i;
        }
      );
    },
    // 转让分页函数
    handleSizeChange(val) {
      this.zrpage = val - 1;
    },
    handleCurrentChange(val) {
      this.zrpage = val - 1;
    },
    // 受让分页函数
    handleSizeChange1(val) {
      this.srpage = val - 1;
    },
    handleCurrentChange1(val) {
      this.srpage = val - 1;
    },
    // 获取用户信息
    async getUser() {
      const res = await getRequest({ url: "/api/v1/user/me" }).catch(() => { });
      if (res.errcode == 200) {
        this.my = res.data;
      }
    },
    // 获取授权中心信息
    getShouQuan() {
      getRequest({ url: "/api/v1/transfer/transferMessage" }).then((res) => {
        if (res.errcode == 200) {
          this.shouQuanData = res.data;
        }
      });
    },
  },
  created() {
    this.getShouQuan();
    this.getUser();
    this.getZrTab();
    this.getSrTab();
    this.getFinancing();
  },
  mounted() {
    if (this.$route.params.tab) {
      this.nav = this.$route.params.tab;
    }
  },
  watch: {
    nav(newVal) {
      if (newVal === '质押融资审核') {
        this.getFinancingReview();
      }
    }
  },
};
</script>

<style lang="scss">
.promise {
  p {
    line-height: 20px;
    margin-bottom: 16px;
  }

  .checkbox {
    margin-top: 50px;
    padding: 0 14px;

    .el-checkbox {
      display: flex;
      white-space: normal !important;

      .el-checkbox__input {
        margin-top: 2px;
      }

      .el-checkbox__label {
        color: #000;
      }
    }
  }
}

.zf_tanchuang {
  position: relative;
  min-height: 500px;

  .zffh_bt {
    border: 0;
    background: #00aeef;
    border-radius: 2px;
    cursor: pointer;
    color: #ffffff;
    padding: 3px 12px;
    margin-top: 12px;
  }

  .cg_icon {
    margin: 0 auto 10px;
  }

  .zfcg_bt {
    position: absolute;
    left: 50%;
    top: 580px;
    color: #ffffff;
    font-size: 16px;
    margin-left: -132px;
    padding: 3px 15px;
    border: 0;
    background: #00aeef;
    border-radius: 5px;
    cursor: pointer;
  }

  .price {
    position: absolute;
    left: 50%;
    top: 250px;
    color: red;
    font-weight: 600;
    font-size: 24px;
    width: 200px;
    margin-left: -180px;
  }

  .zf_bg {
    width: 100%;
  }
}

.my {
  width: 80%;
  margin: 24px auto 60px;


  .el_input {
    .el-input {
      font-size: 12px;
    }

    .el-input__inner {
      padding: 0 5px;
      height: 25px;
    }

    .el-input-group__append,
    .el-input-group__prepend {
      background-color: transparent;
      padding: 0;
    }

    .el-icon-close {
      padding: 0 5px;
    }

    .el-icon-check {
      padding: 0 5px;
    }
  }

  .content {
    flex: 1;

    .rong_zi {
      .col {
        background: #ffffff;
        border-radius: 8px;
        border: 1px solid #e5e6eb;
        padding: 24px;
        margin-bottom: 24px;
      }
    }

    .but {
      position: relative;

      .el-button {
        padding: 5px 24px;
      }

      .a {
        position: absolute;
        right: 0;
        top: 5px;
      }
    }

    .shou_quan {
      .ren_zheng_ti_shi {
        font-size: 14px;
        margin-top: 4px;
        font-weight: 400;
        color: #86909c;
        line-height: 22px;
      }

      .ge_ren {
        .ti_shi {
          font-size: 14px;
          margin-top: 4px;
          font-weight: 400;
          color: #86909c;
          line-height: 22px;
        }
      }

      .ren_zheng {
        font-size: 16px;
        font-weight: 500;
        color: #1d2129;
        line-height: 24px;

        img {
          width: 24px;
          margin-right: 8px;
        }
      }

      .qu {
        font-size: 14px;
        font-weight: 400;
        color: #165dff;
        line-height: 22px;
        cursor: pointer;
        margin-left: 16px;
      }

      .yi {
        font-size: 14px;
        font-weight: 400;
        color: #1d2129;
        margin-left: 12px;
        cursor: pointer;
      }

      .name {
        font-size: 14px;
        margin-left: 10px;
        font-weight: 500;
        color: #1d2129;
        line-height: 22px;
      }

      .ren_zheng_col {
        background: #ffffff;
        border-radius: 4px 4px 4px 4px;
        border: 1px solid #165dff;
        padding-right: 8px;
        margin-right: 20px;
      }

      .yi_ren_zheng {
        width: 80px;
        height: 28px;
        // background: #e8f3ff;
        border-radius: 2px 2px 2px 2px;
        font-size: 14px;
        font-weight: 400;
        color: #165dff;
        line-height: 22px;

        img {
          width: 12px;
          margin-right: 7px;
        }
      }

      .biao_ti {
        font-size: 12px;
        margin-bottom: 12px;
        font-weight: 500;
        color: #86909c;
        line-height: 14px;
      }

      .ge_ren,
      .qi_ye {
        margin-bottom: 24px;
        border-radius: 8px 8px 8px 8px;
        border: 1px solid #e5e6eb;
        padding: 24px;
      }
    }

    .zhaun_rang {
      .fen_ye {
        margin-top: 48px;
      }

      .list {
        margin-top: 24px;

        .col {
          margin-bottom: 24px;

          .col_2 {
            background: #ffffff;
            border-radius: 0px 0px 8px 8px;
            opacity: 1;
            border: 1px solid #e5e6eb;
            border-top: none;
            padding: 19px 24px;

            .buttons {

              &>div,
              a {
                // width: 56px;
                padding: 0 16px;
                height: 28px;
                background: #f2f3f5;
                border-radius: 4px 4px 4px 4px;
                cursor: pointer;
                font-size: 14px;
                font-weight: 400;
                color: #4e5969;
                line-height: 22px;
                margin-left: 12px;
              }

              .lan {
                background: #409eff;
                color: #ffffff;
              }
            }

            .ti_jiao {
              font-size: 13px;
              font-weight: 400;
              color: #86909c;
              line-height: 22px;

              span {
                color: #4e5969;
              }
            }
          }

          .col_1 {
            background: #ffffff;
            border-radius: 8px 8px 0px 0px;
            border: 1px solid #e5e6eb;
            padding: 24px;

            .col_labe {
              font-size: 14px;
              padding: 8px 0;
            }

            .col_list {
              // margin-top: 14px;
              height: 0;
              overflow: hidden;
              transition: all 1s;

              .el-table th.el-table__cell {
                background: #fafafa;
              }

              .el-table .hong {
                color: #eb5757;
              }

              .el-table .lv {
                color: #27ae60;
              }
            }

            .checked_list {
              height: auto;
            }

            .shou_qi {
              font-size: 12px;
              font-weight: 400;
              color: #165dff;
              cursor: pointer;

              .checked_img {
                transform: rotate(180deg);
              }

              img {
                width: 13px;
                margin-left: 7px;
                transition: all 1s;
              }
            }

            .yi_xiang_xx {
              font-size: 12px;
              font-weight: 500;
              color: #86909c;
              line-height: 14px;
            }

            .bian_hao,
            .yi_xiang {
              font-size: 13px;
              font-weight: 400;
              color: #86909c;
              line-height: 22px;
              margin-top: 8px;

              span {
                color: #4e5969;
              }
            }

            .yi_xiang {
              margin-top: 4px;
            }

            .zhaung_tai {
              font-size: 16px;
              font-weight: 500;
              line-height: 24px;
            }

            .a {
              color: #27ae60;
            }

            .b {
              color: #165dff;
            }

            .c {
              color: #f2994a;
            }

            .d {
              color: #eb5757;
            }

            .title {
              font-size: 16px;
              font-weight: 500;
              color: #1d2129;
              line-height: 24px;
              // cursor: pointer;
            }

            .img {
              width: 80px;
              height: 80px;
              border: 1px solid #e5e6eb;
              margin-right: 24px;

              img {
                width: 78px;
                max-height: 78px;
              }
            }
          }
        }
      }

      .el-select {
        width: 120px;
      }

      .ri_li {
        flex: 1;
      }

      .sou_suo {
        width: 261px;
        height: 36px;
        background: #f7f8fa;
        border-radius: 4px 4px 4px 4px;
        padding: 0 15px;
        margin-right: 16px;

        i {
          cursor: pointer;
        }

        input {
          width: 100%;
          border: none;
          outline: none;
          background: #f7f8fa;
          font-size: 14px;
          font-weight: 400;
          line-height: 22px;
          flex: 1;
          margin-right: 10px;
        }
      }

      .tabs {
        margin-bottom: 24px;

        // height: 76px;
        .el-button {
          padding: 5px 14px;
          background-color: #165dff;
          border-color: #165dff;
        }

        .col {
          font-size: 16px;
          font-weight: 400;
          color: #86909c;
          line-height: 24px;
          cursor: pointer;
          padding: 10px 24px 0;
          border-right: #e5e6eb solid 1px;
          margin: 16px 0;
          height: 24px;

          &:last-child {
            border-right: none;
          }
        }

        .checked {
          color: #165dff;
        }
      }
    }

    &>.title {
      font-size: 24px;
      font-weight: bold;
      color: #1d2129;
      line-height: 32px;
      margin-bottom: 24px;
    }
  }

  .navs {
    width: 195px;
    border-radius: 12px 12px 12px 12px;
    padding: 21px 16px;
    border: 1px solid #e5e6eb;
    margin-right: 32px;

    .col {
      width: 100%;
      height: 36px;
      border-radius: 4px 4px 4px 4px;
      padding: 0 16px;
      font-size: 14px;
      font-weight: 400;
      color: #4e5969;
      line-height: 22px;
      cursor: pointer;

      img {
        width: 12px;
        margin-right: 10px;
      }
    }

    .checked {
      background: #f2f3f5;
      color: #165dff;
    }

    .name {
      font-size: 14px;
      font-weight: 500;
      color: #1d2129;
      line-height: 22px;

      i {
        margin-left: 6px;
        cursor: pointer;
      }
    }

    .phono {
      font-size: 12px;
      font-weight: 400;
      color: #86909c;
      line-height: 20px;
    }

    .el-upload-dragger {
      background-color: transparent;
      border: none;
      width: 32px;
      height: 32px;
      border-radius: 50%;
      margin-right: 10px;
    }

    .img {
      width: 32px;
      height: 32px;
      // background: #165dff;
      border-radius: 50%;
      margin-right: 10px;

      img {
        width: 100%;
        height: 100%;
        border-radius: 50%;
      }
    }
  }

  // 质押融资审核列表样式
  .review-card {
    background: #ffffff;
    border: 1px solid #e5e6eb;
    border-radius: 8px;
    padding: 20px;
    margin-bottom: 16px;
    box-shadow: 0 2px 4px rgba(0, 0, 0, 0.05);

    .card-header {
      margin-bottom: 16px;

      .company-section {
        display: flex;
        justify-content: space-between;
        align-items: flex-start;

        .company-name {
          font-size: 16px;
          font-weight: 600;
          color: #1d2129;
          line-height: 24px;
          flex: 1;
          margin-right: 16px;
        }

        .status-section {
          display: flex;
          align-items: center;
          white-space: nowrap;

          .status-label {
            font-size: 14px;
            color: #4e5969;
            margin-right: 8px;
          }

          .status-value {
            font-size: 14px;
            color: #165dff;
            font-weight: 500;
          }
        }
      }
    }

    .card-content {
      margin-bottom: 16px;

      .info-row {
        display: flex;
        margin-bottom: 8px;
        font-size: 14px;
        line-height: 20px;

        .info-label {
          color: #4e5969;
          min-width: 80px;
          margin-right: 8px;
        }

        .info-value {
          color: #1d2129;
          flex: 1;

          &.document-link {
            color: #165dff;
            cursor: pointer;
            text-decoration: underline;
          }

          &.status-link {
            color: #165dff;
            cursor: pointer;
            text-decoration: underline;
          }
        }
      }
    }

    .card-footer {
      display: flex;
      justify-content: space-between;
      align-items: center;
      padding-top: 16px;
      border-top: 1px solid #f2f3f5;

      .amount-section {
        display: flex;
        align-items: center;

        .amount-label {
          font-size: 14px;
          color: #4e5969;
          margin-right: 8px;
        }

        .amount-value {
          font-size: 16px;
          color: #eb5757;
          font-weight: 600;
        }
      }

      .action-section {
        .el-button {
          background: #165dff;
          border-color: #165dff;
          
          &:hover {
            background: #0e4bcc;
            border-color: #0e4bcc;
          }
        }
      }
    }
  }

  .company-info {
    .company-name {
      font-size: 14px;
      font-weight: 500;
      color: #1d2129;
      line-height: 20px;
      margin-bottom: 4px;
    }
    
    .applicant-info {
      font-size: 12px;
      color: #86909c;
      line-height: 16px;
    }
  }
  
  .document-id {
    font-size: 14px;
    color: #1d2129;
    font-family: 'Courier New', monospace;
  }
  
  .apply-date {
    font-size: 14px;
    color: #4e5969;
  }
  
  .amount {
    font-size: 14px;
    color: #eb5757;
    font-weight: 500;
  }
}
</style>
